import { type SelectOption } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Trigger } from 'modules/automations/store/models/Trigger'

import { RecipientTypes } from './utils'

const applicationRecipientTypes = (): SelectOption[] => {
  return [
    {
      value: RecipientTypes.user,
      label: i18n.t('automations.actions.send_notification.recipient_type.user'),
    },
  ]
}

export const defaultRecipientTypes = (): SelectOption[] => {
  return [
    {
      value: RecipientTypes.user,
      label: i18n.t('automations.actions.send_notification.recipient_type.user'),
    },
    {
      value: RecipientTypes.group,
      label: i18n.t('automations.actions.send_notification.recipient_type.group'),
    },
    {
      value: RecipientTypes.manualSelection,
      label: i18n.t('automations.actions.send_notification.recipient_type.manual_selection'),
    },
  ]
}

export const recipientTypes = (trigger: string): SelectOption[] => {
  switch (trigger) {
    case Trigger.Slugs.applicationCreated:
    case Trigger.Slugs.applicationDisqualified:
      return applicationRecipientTypes()

    default:
      return defaultRecipientTypes()
  }
}
